import {defineStore} from 'pinia'
import {useApiRequestStore} from '../../ApiRequestStore/useApiRequestStore'
import {
  IDeleteWorkspaceInvitationRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceInvitationController/validators/DeleteWorkspaceInvitation/types/IDeleteWorkspaceInvitationRequestInterfaces'
import {
  IGetWorkspaceMembersRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceMemberController/validators/GetWorkspaceMembers/types/IGetWorkspaceMembersRequestInterfaces'
import {IGetMembersCountByWorkspaceIds} from '@toolify/server/src/controllers/WorkspaceMemberController/validators/GetMembersCountByWorkspaceIds/types/IGetMembersCountByWorkspaceIds'
import {mapWorkspaceMemberResponseInstance} from '@toolify/client/src/modules/api/singletons/mapWorkspaceMemberResponseInstance'
import {IApiStoreRequestOptions} from '@toolify/client/src/stores/ApiRequestStore/types/IApiStoreRequestOptions'

export const useWorkspaceMemberApiStore = defineStore('workspaceMemberApi', {
  actions: {
    async getWorkspaceMembers(
      workspaceId: string,
      options?: IApiStoreRequestOptions,
    ): Promise<IGetWorkspaceMembersRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {members} = await apiRequestStore.get<IGetWorkspaceMembersRequestInterfaces>(
        `/workspace/${workspaceId}/members`,
        undefined,
        options,
      )
      return {
        members: members.map(member => {
          return mapWorkspaceMemberResponseInstance(member)
        }),
      }
    },

    async getMembersCountByWorkspaceIds(
      workspaceIds: string[],
    ): Promise<IGetMembersCountByWorkspaceIds['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IGetMembersCountByWorkspaceIds>('/workspace/membersCount', {
        data: {
          workspaceIds,
        },
      }, {retryOnNetworkError: true})
    },

    async deleteWorkspaceMember(
      workspaceId: string,
      userId: string,
      substituteUserId?: string,
    ): Promise<IDeleteWorkspaceInvitationRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.delete<IDeleteWorkspaceInvitationRequestInterfaces>(`/workspace/${workspaceId}/members/${userId}`,{
        data: {
          substituteUserId,
        },
      })
    },
  },
})
